import { useInfiniteQuery } from '@tanstack/react-query'
import { useCallback, useState } from 'react'
import { userTaskSpectatorDefaultService } from '../../../../../services/users-tasks/defaults/users-tasks-spectators-defaults'
import type { GetList } from '../../../../../services/users-tasks/defaults/users-tasks-spectators-defaults/types'

export const USERS_TASKS_SPECTATORS_DEFAULTS_QUERY_KEY =
  'getUsersTasksDefaultsSpectators'

export const useGetUsersTasksDefaultsSpectators = (take = 20) => {
  const [params, setParams] = useState({} as GetList.Input)

  const { data, isFetchingNextPage, isLoading, refetch, fetchNextPage } =
    useInfiniteQuery({
      queryKey: [USERS_TASKS_SPECTATORS_DEFAULTS_QUERY_KEY, params],
      initialPageParam: 0,
      staleTime: Infinity,
      queryFn: ({ pageParam }) => {
        return userTaskSpectatorDefaultService.getList({
          take,
          skip: pageParam,
          ...params,
        })
      },
      getNextPageParam: (lastPage, _allPages, lastPageParam) => {
        if (lastPage?.error) return null

        if (lastPage && !lastPage?.data?.length) return null

        return lastPageParam + 1
      },
    })

  const get = useCallback(
    (params: GetList.Input) => {
      setParams(params)
    },
    [setParams],
  )

  return {
    usersTasksSpectatorsDefaults: data?.pages?.flatMap((page) => page?.data),
    isFetchingNextPage,
    isLoading,
    nextPage: fetchNextPage,
    refetch,
    get,
  }
}
